module.exports = __webpack_public_path__ + "img/CO.4734730e.webp";